
export interface ISilkInputData {
    schema_version: string,
    // silking info
    silksPerEar: number,
    viableReceptiveDays: number,
    // plant info
    totalPlantPopulation: number,
    expected50PercentPopulationSilkingDOY: string,
    daysMaxSilkExsertion: number,

    tags: string[]
};

export interface IPollenInputData {
    id: number,
    schama_version: string,
    plantGroupName: string,
    totalPlantPopulation: number,
    pollenPerPlant: number,
    shedDuration: number,
    expected50PercentPopulationSheddingDOY: string,

    tags: string[]
};

export interface IField {
    id: string,
    schama_version: string,
    name: string,
    description: string,
    tags: string[],
    female_ratio: number,
    male_ratio: number,
    latitude: number,
    longitude: number,

    createdBy: string,
    modifiedBy: string

    silkInputData: ISilkInputData, // | null,
    pollenInputData: IPollenInputData[]
};

export const DefaultSilkInputData: ISilkInputData = {
    schema_version: "",
    silksPerEar: 0,
    viableReceptiveDays: 0,
    totalPlantPopulation: 0,
    expected50PercentPopulationSilkingDOY: new Date().toISOString(),
    daysMaxSilkExsertion: 1,

    tags: []
}

export const DefaultPollenInputData: IPollenInputData = {
    id: 0,
    schama_version: "",
    plantGroupName: "",
    totalPlantPopulation: 0,
    pollenPerPlant: 0,
    shedDuration: 1,
    expected50PercentPopulationSheddingDOY: new Date().toISOString(),

    tags: []
}

export const DefaultField: IField = {
    id: "",
    schama_version: "",
    name: "",
    description: "",
    female_ratio: 0,
    male_ratio: 0,
    latitude: 0,
    longitude: 0,
    createdBy: "",
    modifiedBy: "",

    tags: [],

    silkInputData: DefaultSilkInputData,
    pollenInputData: []
}